{
  "close": "Zatvori",
  "notifications": "{count, plural, one {# obavijest} other {# obavijesti}}."
}
